import { ComponentPropsWithoutRef, FC, MouseEvent } from 'react';
import { Button, CircularProgress } from '@mui/material';

type LoadingButtonProps = {
  loading: boolean;
} & ComponentPropsWithoutRef<typeof Button>;

const LoadingButton: FC<LoadingButtonProps> = ({ loading = false, onClick, children, ...rest }) => {
  const handleOnClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
  };

  if (loading) {
    return (
      <Button disabled {...rest}>
        <CircularProgress className="absolute !w-[1em] !h-[1em]" />
        <span className="opacity-0">{children}</span>
      </Button>
    );
  } else {
    return (
      <Button onClick={handleOnClick} {...rest}>
        {children}
      </Button>
    );
  }
};

export default LoadingButton;
